import { Component, Input } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { ServiceType } from 'src/app/shared/models/entities/service';

@Component({
  selector: 'laveo-select-service-type',
  templateUrl: './select-service-type.component.html',
  styleUrls: ['./select-service-type.component.scss']
})
export class SelectServiceTypeComponent {
  @Input() control: AbstractControl | null;
  @Input() typeSize: 'default' | 'small' | 'large' = 'large';
  @Input() values: ServiceType[] = Object.values(ServiceType);

  public get formControl(): UntypedFormControl {
    return this.control as UntypedFormControl;
  }
}
